import React from 'react'

export const Unsplash = ({
	width = '16',
	height = '16',
	color = '#fff',
	className = '',
}) => (
	<svg
		className={className}
		width={width}
		height={height}
		viewBox="0 0 40 36"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path fill="#fff" d="M.7 15.8L9.4 19l3.3 10.8a1 1 0 0 0 1.7.5l4.8-4a1.4 1.4 0 0 1 1.8 0l8.7 6.4a1 1 0 0 0 1.6-.6l6.4-30.9A1 1 0 0 0 36.4.1L.7 13.8a1 1 0 0 0 0 2zm11.5 1.5l17-10.5a.3.3 0 0 1 .3.5l-14 13a3 3 0 0 0-.9 1.8l-.5 3.5a.4.4 0 0 1-.8 0l-1.9-6.4a1.7 1.7 0 0 1 .8-2z"
		/>
	</svg>
)
